import React, { useEffect, useRef, useState } from "react";
import InputField from "../InputField";
import SubmitButton from "../SubmitButton";
import { useOTP } from "../../features/auth/useOTP";
import { useAuthStore } from "../../store/authStore";

export default function ChangePasswordOTPForm({ onSubmit }) {
  const { requestOTP, loading: otpLoading } = useOTP();

  const user = useAuthStore((state) => state.user);

  const [phoneNumber, setPhoneNumber] = useState("");

  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirm, setNewPasswordConfirm] = useState("");

  const [otpSent, setOtpSent] = useState(false);
  const [timer, setTimer] = useState(120);
  const [canResend, setCanResend] = useState(false);

  const [error, setError] = useState("");

  const intervalRef = useRef(null);

  // مدیریت تایمر ارسال مجدد OTP
  useEffect(() => {
    if (otpSent && timer > 0) {
      intervalRef.current = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      setCanResend(true);
      clearInterval(intervalRef.current);
    }

    return () => clearInterval(intervalRef.current);
  }, [otpSent, timer]);

  const validatePhoneNumber = () => {
    if (
      !phoneNumber ||
      phoneNumber.length !== 11 ||
      !phoneNumber.startsWith("09")
    ) {
      setError("لطفاً یک شماره موبایل معتبر ۱۱ رقمی و شروع‌شونده با ۰۹ وارد کنید.");
      return false;
    }

    return true;
  };

  const handleRequestOTP = async () => {
    setError("");

    if (!validatePhoneNumber()) {
      return;
    }

    try {
      await requestOTP(phoneNumber, "reset_password");

      setOtpSent(true);
      setTimer(120);
      setCanResend(false);
    } catch (err) {
      setError(
        err.response?.data?.detail ||
          "ارسال کد تایید با خطا مواجه شد."
      );
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");

    if (!newPassword || newPassword.length < 8) {
      setError("رمز عبور جدید باید حداقل ۸ کاراکتر باشد.");
      return;
    }

    if (newPassword !== newPasswordConfirm) {
      setError("رمز عبور جدید و تکرار آن یکسان نیست.");
      return;
    }

    if (!validatePhoneNumber()) {
      return;
    }

    if (!otpSent) {
      setError("ابتدا کد تایید را دریافت کنید.");
      return;
    }

    if (!otp || otp.length < 4) {
      setError("کد تایید پیامک شده را وارد کنید.");
      return;
    }

    await onSubmit({
      phoneNumber,
      otp,
      newPassword,
      newPasswordConfirm,
    });
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4">

      {/* رمز عبور جدید */}
      <InputField
        label="رمز عبور جدید"
        type="password"
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
      />

      {/* تکرار رمز عبور */}
      <InputField
        label="تکرار رمز عبور"
        type="password"
        value={newPasswordConfirm}
        onChange={(e) => setNewPasswordConfirm(e.target.value)}
      />

      {/* شماره موبایل + دکمه ارسال کد */}
      <div className="flex flex-col gap-1.5">
        <label className="text-sm font-medium text-gray-700">
          شماره موبایل
        </label>

        <div className="flex gap-2">
          <input
            type="text"
            placeholder="مثال: 09123456789"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-left"
            dir="ltr"
          />

          <button
            type="button"
            onClick={handleRequestOTP}
            disabled={(otpSent && !canResend) || otpLoading}
            className={`px-4 py-2 text-sm font-semibold rounded-md border transition whitespace-nowrap ${
              otpSent && !canResend
                ? "bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed"
                : "bg-blue-50 text-blue-600 border-blue-200 hover:bg-blue-100"
            }`}
          >
            {otpLoading
              ? "در حال ارسال..."
              : otpSent
              ? canResend
                ? "ارسال مجدد"
                : "ارسال شد"
              : "دریافت کد"}
          </button>
        </div>
      </div>

      {/* فیلد OTP */}
      {otpSent && (
        <div className="bg-blue-50/50 p-3 rounded-md border border-blue-100 flex flex-col gap-2">
          <InputField
            label="کد تایید پیامک شده"
            name="otp"
            type="text"
            placeholder="کد تایید"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
          />

          {!canResend && (
            <div className="text-xs text-gray-500 pr-1">
              ارسال مجدد کد تا {Math.floor(timer / 60)}:
              {String(timer % 60).padStart(2, "0")} دیگر
            </div>
          )}
        </div>
      )}

      {error && (
        <p className="text-red-600 text-sm pr-1">
          {error}
        </p>
      )}

      <SubmitButton text="تغییر رمز عبور" />

    </form>
  );
}
